import script from "./opponent_page.vue?vue&type=script&setup=true&lang=js"
export * from "./opponent_page.vue?vue&type=script&setup=true&lang=js"

import "./opponent_page.vue?vue&type=style&index=0&id=fb1824da&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb1824da"]])

export default __exports__